document.addEventListener('click', function(event) {
  const clear = event.target.closest('.t4s-active-filters__clear, #t4s-filter-hidden .t4s-mini-search__viewAll');
  if (!clear) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  window.location.assign(clear.href);
}, true);
document.addEventListener('input', function(event) {
  const input = event.target.closest('[data-animix-filter-search]');
  if (!input) return;
  const group = input.closest('[data-animix-filter-group]');
  if (!group) return;
  const term = input.value.toLocaleLowerCase().trim();
  let visible = 0;
  group.querySelectorAll('.t4s-filter__values li').forEach(function(row) {
    row.hidden = !row.textContent.toLocaleLowerCase().includes(term);
    if (!row.hidden && !row.classList.contains('is--disabled')) visible++;
  });
  const empty = group.querySelector('[data-animix-filter-empty]');
  if (empty) empty.hidden = visible > 0;
});
document.addEventListener('keydown', function(event) {
  if (event.key === 'Enter' && event.target.matches('[data-animix-filter-search]')) event.preventDefault();
});
document.addEventListener('submit', function(event) {
  if (!event.target.matches('.t4s-facets__form')) return;
  const range = event.target.querySelector('[data-animix-price-range]');
  if (!range) return;
  const min = range.querySelector('[data-animix-price-min]');
  const max = range.querySelector('[data-animix-price-max]');
  const error = range.querySelector('[data-animix-price-error]');
  if (min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)) {
    event.preventDefault();
    error.textContent = range.dataset.rangeError;
    error.hidden = false;
    min.focus();
  } else {
    error.hidden = true;
    event.preventDefault();
    const url = new URL(event.target.action, window.location.href);
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    const values = new FormData(event.target);
    for (const [key, value] of values) {
      if (!key.startsWith('filter.') && key !== 'page') params.set(key, value);
    }
    for (const field of [min, max]) {
      if (field.value === '') params.delete(field.name);
      else params.set(field.name, field.value);
    }
    url.search = params.toString();
    window.location.assign(url.href);
  }
});